
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[...params]",
      function () {
        return require("private-next-pages/restaurants/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/[...params]"])
      });
    }
  